/* unplugin-vue-components disabled */import { render } from "./accord.vue?vue&type=template&id=1c961d8e&scoped=true"
const script = {}

import "./accord.vue?vue&type=style&index=0&id=1c961d8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c961d8e"]])

export default __exports__